import { ReactElement, RefObject, useContext, useRef } from "react";
import SimpleTextInput from "../presenters/SimpleTextInput";
import { TranscriptHubContext } from "../providers/TranscriptHubProvider";
import TranscriptConfirmationContainer from "./TranscriptConfirmationContainer";

export interface InputInterfaceRef {
  setInputTextAndFocus(text: string): void;
}

export interface InputContainerProps {
  componentRef?: RefObject<InputInterfaceRef>;
  showQuickResponses: boolean;
  showSuggestedAnswer: boolean;
  onShowQuickResponses: () => void;
  onShowSuggestedAnswer: () => void;
}

export default function InputContainer({ componentRef, showQuickResponses, showSuggestedAnswer, onShowQuickResponses, onShowSuggestedAnswer }: InputContainerProps): ReactElement {
  const { isChatOnlyMode, speechConfirmation, isAgentSpeaking, spokenTranscript, sendTextMessage } = useContext(TranscriptHubContext);

  const transcriptConfirmAndEditRef = useRef<InputInterfaceRef>(null);
  const simpleTextInputRef = useRef<InputInterfaceRef>(null);

  if (componentRef) {
    (componentRef as React.MutableRefObject<InputInterfaceRef>).current = {
      setInputTextAndFocus: (text) => {
        transcriptConfirmAndEditRef.current?.setInputTextAndFocus(text);
        simpleTextInputRef.current?.setInputTextAndFocus(text);
      },
    };
  }

  if (speechConfirmation.isEnabled) {
    return (
      <TranscriptConfirmationContainer
        componentRef={transcriptConfirmAndEditRef}
        showQuickResponses={showQuickResponses}
        showSuggestedAnswer={showSuggestedAnswer}
        onShowQuickResponses={onShowQuickResponses}
        onShowSuggestedAnswer={onShowSuggestedAnswer}
        config={speechConfirmation}
        isAgentSpeaking={isAgentSpeaking}
        spokenTranscript={spokenTranscript}
        sendTextMessage={sendTextMessage}
      />
    );
  }
  else {
    return (
      <SimpleTextInput
        componentRef={simpleTextInputRef}
        showQuickResponses={showQuickResponses}
        showSuggestedAnswer={showSuggestedAnswer}
        onShowQuickResponses={onShowQuickResponses}
        onShowSuggestedAnswer={onShowSuggestedAnswer}
        isChatOnlyMode={isChatOnlyMode}
        isAgentSpeaking={isAgentSpeaking}
        sendTextMessage={sendTextMessage}
      />
    );
  }
}
